import { render, staticRenderFns } from "./LiveReports.vue?vue&type=template&id=ac641c94&"
import script from "./LiveReports.vue?vue&type=script&lang=js&"
export * from "./LiveReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac641c94')) {
      api.createRecord('ac641c94', component.options)
    } else {
      api.reload('ac641c94', component.options)
    }
    module.hot.accept("./LiveReports.vue?vue&type=template&id=ac641c94&", function () {
      api.rerender('ac641c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/LiveReports.vue"
export default component.exports